import type { FC } from 'react'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { revealDelay } from '@/lib/motion'
import { Photo } from '@/components/generals/photo'
import { SectionHeading } from '@/components/generals/section-heading'

import { SHELL } from '@/constants/site'

const FACTS = [
    { title: 'تخمیر ۳۶ ساعته', text: 'برای عطر و طعم، درخشش و پوسته‌ای که زیر دندان ترق می‌کند.' },
    { title: 'آرد آسیاب سنگی', text: 'آرام آسیاب می‌شود تا گندم طعم و حال خودش را نگه دارد.' },
    { title: 'هر روز تازه', text: 'هیچ‌چیز برای فردا نمی‌ماند. تمام که شد، دیگر نیست.' }
]

export const ProcessSection: FC = () => (
    <section id='process' aria-labelledby='process-title' className='py-20 lg:py-32'>
        <div className={cn(SHELL, 'grid items-center gap-12 lg:grid-cols-12 lg:gap-10')}>
            <Photo
                src='/images/story/proofing.jpg'
                alt='خمیری که زیر پارچه‌ی کتان، در کاسه‌ای شیشه‌ای آرام‌آرام ور می‌آید'
                sizes='(min-width: 1024px) 45vw, 100vw'
                className='aspect-[4/5] lg:col-span-6'
                position='50% 60%'
            />

            <div className='lg:col-span-5 lg:col-start-8'>
                <SectionHeading
                    id='process-title'
                    label='روش کار ما'
                    title={<>آهسته، <span className='italic'>از سر انتخاب</span></>}
                />

                <div className='mt-7 space-y-5 text-[1.0625rem] leading-relaxed text-crust-soft' data-reveal='up' style={revealDelay(200)}>
                    <p>
                        هر نان یک روز پیش از آنکه به سفره‌ی شما برسد شروع می‌شود. خمیر عصر ورز داده می‌شود، شب‌هنگام با دست تا می‌خورد و یک روز و نیم فرصت تخمیر می‌گیرد؛ همین است که مغز نان را براق و پوسته‌اش را خوش‌طعم و عمیق می‌کند.
                    </p>

                    <p>
                        آردمان را از آسیاب سنگی کوچکی در شمال ایالت می‌آوریم، برای شیرینی‌ها کره‌ی تخمیری به کار می‌بریم و جز این، چیز زیادی لازم نداریم. تنورها ساعت چهار صبح روشن می‌شوند و اولین سینی‌ها همزمان با بیدار شدن محله به پیشخوان می‌رسند.
                    </p>
                </div>

                <dl className='mt-10 grid border-t border-line sm:grid-cols-3'>
                    {FACTS.map((fact, index) => (
                        <div
                            key={fact.title}
                            className='border-b border-line py-5 sm:border-b-0 sm:border-s sm:py-0 sm:pt-6 sm:ps-5 sm:first:border-s-0 sm:first:ps-0'
                            data-reveal='up'
                            style={revealDelay(240 + index * 120)}
                        >
                            <dt className='font-heading text-[1.6rem] leading-snug'>{fact.title}</dt>
                            <dd className='mt-2 text-sm leading-relaxed text-crust-soft'>{fact.text}</dd>
                        </div>
                    ))}
                </dl>

                <Link href='/our-story' className='link-underline mt-10 inline-flex items-center gap-2 text-sm font-medium' data-reveal='up'>
                    داستان ما را بخوانید
                    <ArrowRight className='size-4 rtl:-scale-x-100' aria-hidden='true' />
                </Link>
            </div>
        </div>
    </section>
)
